module.exports = __webpack_public_path__ + "2c2118120c32e77754272a30ccb4af61.png";